import { isNotNullish } from '@y42/util/nullish';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Point } from '../types/point';

export interface ClickOrTouchEvent {
  event: TouchEvent | MouseEvent;
  point: Point;
}

export const mapTouchToPoint =
  () =>
  (source: Observable<TouchEvent>): Observable<ClickOrTouchEvent> =>
    source.pipe(
      map((event: TouchEvent) => {
        const eventTouch = event.touches[0];
        return eventTouch
          ? {
              event,
              point: { x: eventTouch.clientX, y: eventTouch.clientY },
            }
          : undefined;
      }),
      filter(isNotNullish),
    );

export const mapClickToPoint =
  () =>
  (source: Observable<MouseEvent>): Observable<ClickOrTouchEvent> =>
    source.pipe(map((event: MouseEvent) => ({ event, point: { x: event.clientX, y: event.clientY } })));

export const mapTouchToTarget = () => (source: Observable<TouchEvent>) =>
  source.pipe(
    map((event: TouchEvent) => event.touches[0]?.target),
    filter(Boolean),
  );

export const mapClickToTarget = () => (source: Observable<MouseEvent>) =>
  source.pipe(
    filter(({ target }: MouseEvent) => !!target),
    map(({ target }: MouseEvent) => target as EventTarget),
  );
